/**
 * 未対応pt 明細モーダル
 * 未対応pt カードのクリックで気泡式に展開し、未対応（status=未対応・親チケットあり）の
 * 子チケット明細（予定pt）を表示する。チケットキーは Backlog の該当票へリンクする。
 *
 * @graph-stack product-innovation-lab
 * @graph-domain Engineering
 * @graph-business 未対応子チケットの予定pt 明細モーダル（現在スナップショット）。Backlog 票へのリンク付き
 * @graph-connects useMemberOpenPoints [calls] 未対応pt 明細フック（モーダルを開くまで遅延）
 */
import { useTranslation } from 'react-i18next';
import { Modal } from '@cortex/web-design-system/components/ui/Modal';
import { useMemberOpenPoints } from '../../hooks/useMember.js';
import { formatNum } from './combat-power/combat-power-utils.js';
import { PtDetailTable, SectionSpinner } from './pt-detail.js';

/** @graph-connects none */
interface OpenPtDetailModalProps {
  /** メンバーのメールアドレス */
  email: string;
  /** モーダル表示状態 */
  open: boolean;
  /** クローズ要求コールバック */
  onClose: () => void;
}

/** @graph-connects useMemberOpenPoints [calls] 未対応pt 明細フック */
export function OpenPtDetailModal({ email, open, onClose }: OpenPtDetailModalProps) {
  const { t } = useTranslation();

  // open のときだけ取得（モーダルを開くまで遅延。カード側の合計取得とは queryKey 単位で dedupe される）
  const { data, isLoading } = useMemberOpenPoints(email, open);

  // 予定pt=0 の未対応チケットは明細に出さない（見積り未入力の票でリストを埋めない）
  const rows = (data?.data ?? []).filter((row) => row.point > 0);

  return (
    <Modal
      open={open}
      onClose={onClose}
      title={t('members.quarterlyKpi.openPtDetail.title')}
      description={t('members.quarterlyKpi.openPtDetail.description', {
        value: formatNum(data?.totalPoint ?? 0, 1),
      })}
      size="full"
      className="animate-bubble-in md:max-w-7xl"
    >
      <div className="space-y-6">
        {isLoading ? (
          <SectionSpinner />
        ) : rows.length > 0 ? (
          <PtDetailTable rows={rows} />
        ) : (
          <p className="text-sm text-[var(--color-text-muted)]">
            {t('members.quarterlyKpi.ptDetail.empty')}
          </p>
        )}

        {/* 注記: pt は予定pt（未着手のため実績なし）、現在スナップショット */}
        <p className="text-xs text-[var(--color-text-muted)]">
          {t('members.quarterlyKpi.openPtDetail.note')}
        </p>
      </div>
    </Modal>
  );
}
